import { Head, Link, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = {
    status?: string | null;
};

type FormShape = {
    email: string;
    password: string;
    remember: boolean;
};

export default function Login({ status }: Props) {
    const form = useForm<FormShape>({
        email: '',
        password: '',
        remember: false,
    });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/login');
    }

    return (
        <PublicLayout>
            <Head title="Log in" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[32px] leading-tight text-ink mb-6">Log in</h1>

                {status && (
                    <div className="mb-4 text-[14px] text-emerald-700">{status}</div>
                )}

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label htmlFor="login-email" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Email
                        </label>
                        <input
                            id="login-email"
                            type="email"
                            autoComplete="username"
                            required
                            value={form.data.email}
                            onChange={(e) => form.setData('email', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                        {form.errors.email && <p className="text-[12px] text-red-700 mt-1">{form.errors.email}</p>}
                    </div>

                    <div>
                        <label htmlFor="login-password" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Password
                        </label>
                        <input
                            id="login-password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={form.data.password}
                            onChange={(e) => form.setData('password', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                    </div>

                    <label className="flex items-center gap-2 text-[14px]">
                        <input
                            type="checkbox"
                            checked={form.data.remember}
                            onChange={(e) => form.setData('remember', e.target.checked)}
                        />
                        Remember me
                    </label>

                    <Btn type="submit" full loading={form.processing}>
                        Log in
                    </Btn>

                    <div className="text-center text-[13px] mt-4">
                        <Link href="/magic-link" className="text-ember underline">Sign in with email link instead</Link>
                    </div>

                    <div className="flex justify-between text-[13px] mt-2">
                        <Link href="/forgot-password" className="text-ember underline">Forgot password?</Link>
                        <Link href="/register" className="text-ember underline">Create account</Link>
                    </div>
                </form>
            </div>
        </PublicLayout>
    );
}
